module.exports = __webpack_public_path__ + "img/1.9bf536b6.png";